import React, { Component } from "react";
import { graphql } from "react-apollo";
import { Link } from "react-router-dom";
import _ from "lodash";

// Components
import ResultsWithCharts from "./ResultsWithCharts/";
import ResultsToCSV from "./ResultsToCSV/";
import ResultItem from "./ResultItem";

// Query
import query from "../../../../queries/fetchResults";

class SurveyResults extends Component {

  renderResultsToCSV() {

    const { surveyResults } = this.props.data;
    const surveyId = this.props.match.params.id;

    if (!surveyResults) {
      return null;
    }

    return <ResultsToCSV surveyId={surveyId} />;

  }

  renderResultsWithCharts() {

    const { surveyResults, surveyById } = this.props.data;

    if (!surveyById || !surveyResults) {
      return null;
    }

    const fieldcollection = surveyById.fieldcollection || [];

    return (
      <ResultsWithCharts
        data={surveyResults}
        fieldcollection={fieldcollection}
        totalResults={surveyResults.length}
      />
    );

  }

  renderResultItem() {

    const { surveyResults } = this.props.data;

    if (!surveyResults || !Array.isArray(surveyResults)) {
      return null;
    }

    return _.map(surveyResults, result => (
      <ResultItem key={result.id} data={result} />
    ));

  }

  render() {

    if (this.props.data.loading) {
      return <div className="loader">Loading...</div>;
    }

    if (!this.props.data.surveyResults) {
      return <div>No hay resultados para esta encuesta.</div>;
    }

    return (

      <div className="container">

        <h1>Resultados</h1>

        <div className="mb-2">
          Total de encuestados: {this.props.data.surveyResults.length}
        </div>

        <div className="mb-2">
          {this.renderResultsToCSV()}
        </div>

        <div className="mb-4">

          <Link
            to="/admin/visor"
            className="btn btn-primary"
          >
            Visor Universal
          </Link>

        </div>

        {this.renderResultsWithCharts()}

        {this.renderResultItem()}

      </div>

    );

  }

}

export default graphql(query, {

  options: props => ({
    variables: {
      surveyId: props.match.params.id
    }
  })

})(SurveyResults);


// WEBPACK FOOTER //
// ./src/components/Admin/surveys/Results/index.js